module.exports = require('./lib/ReactWithAddons');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/addons.js
 ** module id = 671
 ** module chunks = 0
 **/